export default "__VITE_ASSET__CzmLCcRs__"